/* @flow */
import React from 'react';
import { Container } from 'flux/utils';
import Activity from 'entities/Activity';
import ActivityStore from 'payments/stores/ActivityStore';
import ActivityTransactionsModal from 'payments/components/ActivityTransactionsModal.jsx';

type State = {
  activity: Activity,
};

type Props = {
  activityID: string,
}

class ActivityTransactionsModalContainer extends React.Component {
  props: Props;
  state: State;

  static getStores() {
    return [ActivityStore];
  }

  static calculateState(_prevState, props: Props) {
    return {
      activity: ActivityStore.getActivityById(props.activityID),
    };
  }

  render() {
    return <ActivityTransactionsModal {...this.props} activity={this.state.activity} />;
  }
}

export default Container.create(ActivityTransactionsModalContainer, { withProps: true });



// WEBPACK FOOTER //
// ./src/payments/containers/ActivityTransactionsModalContainer.jsx